
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes01 as ObiDiodes01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-01.js';
 
 
 

 
 export const ObiDiodes01 = createComponent({
   react: React,
   tagName: 'obi-diodes-01',
   elementClass: ObiDiodes01Element,
   events: {
     
   }
  });
 
 